// @flow
import each from './each';

type Callback<T, K> = (T, number, Array<T>) => K

export default function map<T, K>(array: Array<T>, callback: Callback<T, K>): Array<K> {
   const memo = [];
   // $FlowFixMe
   each(array, (val, key, arr) => memo.push(callback(val, key, arr)) );
   return memo;
}
